var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',_vm._b({},'loader',{ loading: _vm.loading },false),[_c('div',{staticClass:"box"},[_c('div',{staticClass:"columns"},[(_vm.canTransferAssets())?_c('transfer-tool'):_vm._e(),(_vm.hasAbility('decommission-assets'))?_c('decommission-tool'):_vm._e(),(_vm.hasAbility('manage-sub-assets'))?_c('assign-tool'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }